import React, { useContext } from "react";


function CardLayout({ children, size = "large" }) {
    const sizeClass = `card-layout-${size}`;

    return (
        <div className={`primary-card-layout ${sizeClass}`}>
            {children}
        </div>
    )
}

export default CardLayout;